module.exports = __webpack_public_path__ + "img/food_candy.12feab3a.jpg";